import React from 'react';
import { useParams } from 'react-router-dom';
import FormAddEditPostTag from '../../../components/blog/tags/FormAddEditPostTag';
import { useGetPostTagById } from '../../../hooks/blog/tags/useGetPostTagById';
import LoadingSpinner from '../../../components/global/LoadingSpinner';
import ErrorAlert from '../../../components/global/ErrorAlert';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const EditPostTag = () => {
    const { id } = useParams();

    const { tag, isLoading, error } = useGetPostTagById(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <LoadingSpinner />
            </WrapperSection>
        );
    }
    if (error) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <ErrorAlert error={error} />
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPostTag currentData={tag} isEdit={true} />
        </WrapperSection>
    );
};

export default EditPostTag;
